import PropTypes from 'prop-types';

export const propTypes = {
  paymentCardData: PropTypes.object,
  handleShowTermsConditionsModal: PropTypes.func,
};
